import { Component } from '@angular/core';
import { LoadingService } from 'src/app/domain/loading/loading.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading',
  template: '<ngx-loading [show]="loading | async"></ngx-loading>'
})
export class LoadingComponent {
  public loading: Observable<boolean> = this.loadingService.loading;

  constructor(public loadingService: LoadingService) {}
}
